export default __webpack_public_path__ + "static/media/name-profile-active.73becda0.svg";